import { Box, CircularProgress, Grid } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

import Layout from '../Page';
import TopSingleCards from './TopSingleCards';
import HalfCards from './HalfCards';
import useIsMobile from '../../hooks/useIsMobileHook';
import { withAuthorization } from '../Session';
import MainDropdown from './MainDropdown';
import useProductCounts from '../../hooks/useFetchProductToMakeData';
import useAveragesForOrders from '../../hooks/useAveragesForOrders';
// import TopHalfCards from './TopHalfCards';
// import ShipCard from './ShipCard';

const Analytics = (props) => {
  const dispatch = useDispatch();

  const { isLoading, mainDropDownProduct } = useSelector(
    (state) => state.analyticsState,
  );

  const isMobile = useIsMobile();

  const db = props.firebase.getdb();

  const specificProductCounts = useProductCounts(db);

  // custom hook to get data for averages, and to also update averages....

  const { timedAnalytics, loading } = useAveragesForOrders(db);

  // ! REQUESTED TO REMOVE THESE TWO
  const filteredTimedAnalytics = timedAnalytics.filter(
    (item) => item.title !== 'Oldest Order' && item.title !== 'Makeup Orders',
  );

  return (
    <Layout page="analytics" user={props.user}>
      <Box sx={styles.container}>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Grid
              container
              spacing={isMobile ? 1 : 2}
              sx={{
                alignItems: 'center',
              }}
            >
              {filteredTimedAnalytics.map((card, index) => {
                const keyValue = index + card.title;
                // Apply specific width rules for the first card on mobile view
                const xsWidth = index === 0 ? 12 : 6; // 100% width for the first card, 50% for others
                return (
                  <Grid
                    item
                    xs={xsWidth}
                    sm={4}
                    md={4}
                    lg={2}
                    xl={4}
                    key={keyValue}
                  >
                    <TopSingleCards
                      keyValue={keyValue}
                      title={card.title}
                      data={card.data}
                      icon={card.icon}
                      isMobile={isMobile}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Grid>
              <MainDropdown
                isMobile={isMobile}
                mainDropDownProduct={mainDropDownProduct}
                dispatch={dispatch}
              />

              {specificProductCounts &&
                Object.keys(specificProductCounts).length > 0 &&
                specificProductCounts[mainDropDownProduct] && (
                  <HalfCards
                    keyValue="barCards"
                    mainDropDownProduct={mainDropDownProduct}
                    title="barCards"
                    data={specificProductCounts}
                    dispatch={dispatch}
                    isMobile={isMobile}
                    db={db}
                  />
                )}
            </Grid>
          </>
        )}
      </Box>
    </Layout>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    paddingTop: 2,
    height: '100vh',
    minHeight: '100vh',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflowX: 'hidden',
  },
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(Analytics);

/**
 * 
 * 
    <Grid item xs={12} md={6} lg={4} xl={3}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: !isMobile ? 'column' : 'row',
                    gap: !isMobile ? 2.5 : 1,
                    justifyContent: 'space-between',
                  }}
                >
                  {oldestAndMakeup.map((card, index) => {
                    const keyValue = index + card.title;
                    return (
                      <TopHalfCards
                        isMobile={isMobile}
                        keyValue={keyValue}
                        title={card.title}
                        data={card.data}
                        icon={card.icon}
                      />
                    );
                  })}
                </Box>
              </Grid>
 <>
            <MainDropdown
              isMobile={isMobile}
              mainDropDownProduct={mainDropDownProduct}
            />

            <Grid container>
              {onlyToBeProduced.map((card, index) => {
                const keyValue = card.title + '_' + index;
                return (
                  <Grid item xl={12} key={keyValue}>
                    <HalfCards
                      mainDropDownProduct={mainDropDownProduct}
                      keyValue={keyValue}
                      title={card.title}
                      data={card.data}
                      dispatch={dispatch}
                      value={card.value}
                      itemsWithErrors={itemsWithErrors}
                      isMobile={isMobile}
                      db={db}
                    />
                  </Grid>
                );
              })}
            </Grid>

            <Grid
              container
              sx={{
                paddingBottom: 5,
              }}
            >
              <ShipCard
                isMobile={isMobile}
                keyValue="shipCard"
                data={shipmentData}
                unshippedDataForGraph={unshippedDataForGraph}
                dispatch={dispatch}
              />
            </Grid>
 */
